import { useEffect, useState } from 'react';

import { Button } from 'components/ui';

type Props = {
  onClick: () => void;
};

export const DeclineSubscriptionButton: React.FC<Props> = ({ onClick }) => {
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      setLoading(false);
    };
  }, []);

  return (
    <Button
      data-testid="decline-subscription-button"
      loading={loading}
      onClick={() => {
        setLoading(true);
        onClick();
      }}
    >
      Don't Subscribe
    </Button>
  );
};
